import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import SessionProvider from '../../context/SessionProvider';

function PrivateRouter() {
  const navigate = useNavigate();

  // Funcion que verifica si hay una sesion valida
  const checkSession = () => {
    const session = localStorage.getItem('session') || '';
    return session !== ''; // Retorna true si hay sesion, false si no
  };

  useEffect(() => {
    // Si no hay sesion, redirige a la pagina de inicio
    if (!checkSession()) {
      navigate('/');
    }
  }, [navigate]);

  // Si la sesion es valida, renderiza el Outlet
  return checkSession() ? (
    <SessionProvider>
      <Outlet />
    </SessionProvider>
  ) : null;
}

export default PrivateRouter;
